<template>
    <div>
        <div class="addressBg">
            <div class="address_box">
                <div class="city">
                    <div class="city_choice">
                        <img class="dw" src="../../img/szcs.png" alt />
                        <p>{{ city }}{{ addr }}</p>
                        <img class="qh" src="../../img/qh.png" alt @click="choiceCity()" />
                    </div>
                    <div class="city_show">
                        <div class="block city_show_1">
                            <el-cascader
                                ref="myCascader"
                                v-model="value"
                                :options="data"
                                @click="choiceCity()"
                                @change="handleChange"
                            ></el-cascader>
                            <p class="kf_btn" @click="makePhoneCall">客服电话</p>
                        </div>
                    </div>
                </div>
                <div class="m-tab">
                    <div
                        v-for="(item,index) in order_source_list"
                        :key="index"
                        class="tab-item"
                        :class="order_source == item.key ? 'activeClass' : ''"
                        @click="changeTab(item.key)"
                    >
                        {{ item.value }}
                    </div>
                </div>
                <div class="price" :class="{ topPrice: model === 1 }">
                    <div class="load" v-loading="loading">
                        <div v-show="priceShow">
                            <div class="price1_1">{{ regName }}价格表</div>
                            <div v-if="model === 0">
                                <div class="price2" v-for="item in priceList" v-show="priceShow">
                                    <p class="p2">
                                        含{{ item.startkilometre }}km
                                        <span>
                                            ({{ item.servicetime[0] }}-{{ item.servicetime[1] }})
                                        </span>
                                    </p>
                                    <p class="p1">
                                        微信叫代驾只需
                                        <span>{{ item.startprice }}</span>
                                        元
                                    </p>
                                    <p class="p4">
                                        超出每
                                        <span>{{ item.nextkilometre }}km</span>
                                        加收
                                        <span>{{ item.nextprice }}</span>
                                        元，不足
                                        <span>{{ item.nextkilometre }}km</span>
                                        按照
                                        <span>{{ item.nextkilometre }}km</span>
                                        计算
                                    </p>
                                    <div class="price4">
                                        <p class="p7">等待时间：</p>
                                        <p class="p8">
                                            {{ item.waittime }}分钟免费，超过{{
                                                item.nextwaittime
                                            }}分钟{{ item.addwaittime }}元不满{{
                                                item.nextwaittime
                                            }}分钟按{{ item.nextwaittime }}分钟计算
                                            <span v-if="item.minprice > 0">
                                                (最低消费{{ item.minprice }}元)
                                            </span>
                                        </p>
                                    </div>
                                    <p v-show="item.rangeover > 0" class="p9">
                                        远途费，超过{{ item.rangeover }}公里以后，每{{
                                            item.rangepercent
                                        }}公里（超过{{ item.overrange }}km收费）加收{{
                                            item.addrange
                                        }}元
                                    </p>
                                </div>
                            </div>
                            <div class="chagrgeStandard_wrap" v-else>
                                <div v-for="(item, index) in priceList" :key="index">
                                    <div class="item">
                                        <p class="item_label">服务时间</p>
                                        <p class="item_value">
                                            {{ item.servicetime[0] }}～{{ item.servicetime[1] }}
                                        </p>
                                    </div>
                                    <div class="item col_red" v-if="item.in_fence.maxprice > 0">
                                        <p class="item_label">区域内封顶价</p>
                                        <p class="item_value">
                                            {{ item.in_fence.maxprice }}元(含{{
                                                item.in_fence.in_startminute
                                            }}分钟)
                                        </p>
                                    </div>
                                    <div>
                                        <div class="item">
                                            <p class="item_label">起点在区域内起步价</p>
                                            <p class="item_value">
                                                {{ item.in_fence.in_startprice }}元（含{{
                                                    item.in_fence.in_startkilometre
                                                }}公里，{{ item.in_fence.in_startminute }}分钟）
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域内里程计费</p>
                                                <p class="item_tip">
                                                    超出起步价包含公里数后
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.in_fence.in_nextprice }}元/{{
                                                    item.in_fence.in_nextkilometre
                                                }}公里
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域内时长计费</p>
                                                <p class="item_tip">
                                                    超出起步价包含时长后
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.in_fence.in_addstarttime }}元/{{
                                                    item.in_fence.in_nextstarttime
                                                }}分钟
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域外里程计费</p>
                                                <p class="item_tip">
                                                    超出区域外里程费
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.in_fence.out_nextprice }}元/{{
                                                    item.in_fence.out_nextkilometre
                                                }}公里
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域外时长计费</p>
                                                <p class="item_tip">
                                                    超出区域时长费
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.in_fence.out_addstarttime }}元/{{
                                                    item.in_fence.out_nextstarttime
                                                }}分钟
                                            </p>
                                        </div>
                                    </div>
                                    <div class="outside">
                                        <div class="item">
                                            <p class="item_label">起点在区域外起步价</p>
                                            <p class="item_value">
                                                {{ item.out_fence.in_startprice }}元（含{{
                                                    item.out_fence.in_startkilometre
                                                }}公里，{{ item.out_fence.in_startminute }}分钟）
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域内里程计费</p>
                                                <p class="item_tip">
                                                    超出起步价包含公里数后
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.out_fence.in_nextprice }}元/{{
                                                    item.out_fence.in_nextkilometre
                                                }}公里
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域内时长计费</p>
                                                <p class="item_tip">
                                                    超出起步价包含时长后
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.out_fence.in_addstarttime }}元/{{
                                                    item.out_fence.in_nextstarttime
                                                }}分钟
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域外里程计费</p>
                                                <p class="item_tip">
                                                    超出区域外里程费
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.out_fence.out_nextprice }}元/{{
                                                    item.out_fence.out_nextkilometre
                                                }}公里
                                            </p>
                                        </div>
                                        <div class="item">
                                            <div class="item_label">
                                                <p>区域外时长计费</p>
                                                <p class="item_tip">
                                                    超出区域时长费
                                                </p>
                                            </div>
                                            <p class="item_value">
                                                {{ item.out_fence.out_addstarttime }}元/{{
                                                    item.out_fence.out_nextstarttime
                                                }}分钟
                                            </p>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="item_label">
                                            <p>超时等待费用</p>
                                            <p class="item_tip">
                                                订单开始出发前免费等待{{ item.in_fence.waittime }}分钟
                                            </p>
                                        </div>
                                        <p class="item_value">
                                            {{ item.in_fence.addwaittime }}元/{{
                                                item.in_fence.nextwaittime
                                            }}分钟
                                        </p>
                                    </div>
                                </div>
                                <div
                                    id="mycontainer"
                                    style="width: 100%;height:900px;overflow: hidden;"
                                />
                            </div>
                        </div>
                        <div class="noPrice" v-show="nopriceShow">抱歉，该区域暂未开放。</div>
                        <div class="price3" v-show="priceShow">{{ remarks }}</div>
                    </div>
                </div>
                <div class="ques_wrap">
                    <p class="title">常见问题</p>
                    <div class="ques_uls">
                            <div class="ques_lis">
                                <div class="ques_lis_flex" @click="onQuesShow(0)">
                                    <p class="lis_title">为什么预估价格与实际支付价格不一样?</p>
                                <img src="../../img/common_icon_back.png" class="img_arrow" :class="quesBool[0] ? 'up' : 'down'"></img>
                                </div>
                                <div class="lis_detail" v-if="quesBool[0]">
                                    <p>1、下单前看到的预估价格是根据当时的实时路况预估行驶里程、时长计算得出，预估计仅供参考.</p>
                                    <p>2、实际支付价格是根据行程实际行驶的时长和距离计费的，天气路况等都会影响实际行驶的时长和距离，从而最终影响订单费用.</p>
                                </div>
                            </div>
                            <div class="ques_lis">
                                <div class="ques_lis_flex" @click="onQuesShow(1)">
                                    <p class="lis_title">同样的路线，为什么现在比以前更贵?</p>
                                    <img src="../../img/common_icon_back.png" class="img_arrow" :class="quesBool[1]?'up':'down'"></img>
                                </div>
                                <div class="lis_detail" v-if="quesBool[1]">
                                    <p>1、不同时段、不同代驾类型、不同路况、不同代驾券、不同权益都可能导致这次费用和以前有差异。</p>
                                </div>
                            </div>
                            <div class="ques_lis">
                                <div class="ques_lis_flex" @click="onQuesShow(2)">
                                    <p class="lis_title">什么是时长费/远途费/远程调度费/临时加价费?</p>
                                    <img src="../../img/common_icon_back.png" class="img_arrow" :class="quesBool[2]?'up':'down'"></img>
                                </div>
                                <div class="lis_detail" v-if="quesBool[2]">
                                    <p>1、时长费/远途费:是系统计价规则的一种费用项，不同城市不同时段收费不一样，详情可查看计价规则。</p>
                                    <p>2、远程调度费:当附近无空闲司机而远处有司机时，用户可自行选择是否调用远处司机来接单。若用户选择调度，则需补偿接驾司机远程调度费。</p>
                                    <p>3、临时加价费:当处于雨雪天气、高峰时段等附近司机较少的情况下，临时加价可促进成交。临时加价会有倍数和金额的双重封顶。</p>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import $ from 'jquery'
import {config} from '../../utils/config'
export default {
    name: 'index',
    data() {
        return {
            model: 0,
            value: [],
            data: [],
            cityVal: '',
            order_address: '',
            order_lng: '',
            order_lat: '',
            adcode: '',
            addr: '',
            bgShow: false,
            regId: '',
            cityLaber: '',
            yuantu: true,
            regName: '',
            loading: false,
            priceList: '',
            priceShow: true,
            nopriceShow: false,
            remarks: '',
            province: '',
            city: '',
            district: '',
            kf_tel: '',
            map: null,
            fenceData: [],
            quesBool: {0:false,1:false,2:false},
            order_source: '3',
            order_source_list: [
                { key: '3', value: '公众号/小程序' },
                { key: '1', value: '电话预约' },
                { key: '4', value: '司机补单' },
                { key: '5', value: '客户经理' },
                { key: '6', value: '商户代叫' }
            ]
        }
    },
    methods: {
        selfAdaption(Arr) {
            let bounds = new TMap.LatLngBounds()
            Arr.forEach((item) => {
                if (bounds.isEmpty() || !bounds.contains(item)) {
                    bounds.extend(item)
                }
            })
            //   设置地图可视范围
            this.map.fitBounds(bounds, {
                padding: 10 //自适应边距
            })
        },
        async initMap() {
            //定义地图中心点坐标
            var center = new TMap.LatLng(24.44579, 118.08243)
            //定义map变量，调用 TMap.Map() 构造函数创建地图
            this.map = new TMap.Map(document.getElementById('mycontainer'), {
                center: center, //设置地图中心点坐标
                zoom: 17, //设置地图缩放级别
                pitch: 43.5, //设置俯仰角
                rotation: 45 //设置地图旋转角度
            })
            if (!this.fenceData || !this.fenceData.length) return
            let allPaths = []
            this.fenceData.map((item, index) => {
                let path = []
                item.newpath.forEach((pitem) => {
                    path.push(new TMap.LatLng(pitem.lat, pitem.lng))
                })
                allPaths = [...allPaths, ...path]
                var polygon = new TMap.MultiPolygon({
                    id: `polygon-layer_${index}`, // 图层id
                    map: this.map, // 显示多边形图层的底图
                    styles: {
                        // 多边形的相关样式
                        polygon: new TMap.PolygonStyle({
                            color: 'rgba(0,0,0,0.3)', // 面填充色
                            showBorder: true, // 是否显示拔起面的边线
                            borderWidth: 4,
                            borderColor: '#4192d7' // 边线颜色
                        })
                    },
                    geometries: [
                        {
                            id: `polygon_${index}`, // 多边形图形数据的标志信息
                            styleId: 'polygon', // 样式id
                            paths: path, // 多边形的位置信息
                            properties: {
                                // 多边形的属性数据
                                title: 'polygon'
                            }
                        }
                    ]
                })
            })
            this.selfAdaption(allPaths)
        },
        getMyLocation() {
            var geolocation = new qq.maps.Geolocation(
                config[config.env].baiduKey,
                '洪师傅-h5'
            )
            // geolocation.getIpLocation(this.showPosition, this.showErr)
            geolocation.getLocation(this.showPosition, this.showErr) //或者用getLocation精确度比较高
        },
        showPosition(position) {
            console.log('position', position)
            var value = []
            this.adcode = position.adcode
            var pro = position.adcode.toString().substring(0, 2)
            var city = position.adcode.toString().substring(0, 4)
            var addr = position.adcode.toString()
            value.push(pro, city, addr)
            this.value = value
            this.order_lat = position.lat
            this.order_lng = position.lng
            this.city = position.city
            this.addr = position.addr
            this.getCity()
            this.getPrice()
            this.getCompanyInfo(this.$route.query.service_id, position.lng, position.lat)
        },
        showErr() {
            console.log('定位失败')
            this.getMyLocation() //定位失败再请求定位，测试使用
        },
        handleChange(value) {
            this.regName =
                this.$refs.myCascader.getCheckedNodes()[0].pathLabels[1] +
                this.$refs.myCascader.getCheckedNodes()[0].pathLabels[2]
            this.regId = value[2]
            this.$axios
                .get('/api/wechat/company/charge_standard', {
                    id: this.regId
                })
                .then(async (res) => {
                    this.loading = true
                    if (res.code == 200) {
                        setTimeout(() => {
                            this.loading = false
                            this.priceShow = true
                            this.nopriceShow = false
                        }, 100)
                        this.priceList = res.data.standard
                        this.remarks = res.data.remark
                        this.kf_tel = res.data.kf_tel
                        this.model = res.data.charge_standard_type
                        if (this.model === 1) {
                            await this.getFence()
                            setTimeout(() => {
                                this.initMap()
                            }, 3000)
                        }
                    }
                    if (res.code == 422) {
                        setTimeout(() => {
                            this.loading = false
                            this.priceShow = false
                            this.nopriceShow = true
                        }, 100)
                    }
                })
        },
        // 获取围栏数据
        getFence() {
            this.$axios
                .get('/api/company/standardfence', {
                    id: this.regId || this.adcode
                })
                .then((res) => {
                    this.fenceData = res.data
                })
        },
        choiceCity() {
            $('.el-input').click()
            this.cityVal = $('.el-input__inner').val()
        },
        getCity() {
            this.$axios.get('/api/wechat/region/list').then((res) => {
                this.data = res.data
            })
        },
        getPrice() {
            this.$axios
                .get('/api/wechat/company/charge_standard', {
                    id: this.adcode,
                    source_id: this.order_source
                    // lng: this.order_lng,
                    // lat: this.order_lat
                })
                .then(async (res) => {
                    this.loading = true
                    if (res.code == 200) {
                        this.remarks = res.data.remark
                        this.priceList = res.data.standard
                        this.model = res.data.charge_standard_type
                        if (this.model === 1) {
                            await this.getFence()
                            setTimeout(() => {
                                this.initMap()
                            }, 3000)
                        }
                        setTimeout(() => {
                            this.loading = false
                        }, 100)
                    }
                    if (res.code == 422) {
                        setTimeout(() => {
                            this.loading = false
                            this.priceShow = false
                            this.nopriceShow = true
                        }, 100)
                    }
                })
        },
        getCompanyInfo(service_id, lng, lat) {
            // 定位获取公司信息 - 客服电话
            this.$axios
                .get('/api/wechat/info/companyinfo', {
                    service_id,
                    lng,
                    lat
                })
                .then((res) => {
                    if (!res.data) return
                    this.kf_tel = res.data.kf_tel
                })
        },
        makePhoneCall() {
            if (this.kf_tel) {
                window.location.href = `tel:${this.kf_tel}`
            }
        },
        onQuesShow(index){
            console.log('index',index)
            const quesBool = this.quesBool
            quesBool[index] = !quesBool[index]
            this.quesBool = quesBool
            console.log('this.quesBool',this.quesBool)
        },
        changeTab(e) {
            this.order_source = e
            this.getPrice()
        }
    },
    created() {
        // this.$axios.get('https://apis.map.qq.com/ws/geocoder/v1/?location= ',{
        //   location:'24.472775,118.155727',
        //   key:'CCHBZ-QHXK5-4VKIO-QYX6L-ODEHV-EZBXB'
        // }).then(res=>{
        //   console.log(res)
        //   // console.log('res')
        // })
    },
    mounted() {
        this.getCity()
        // this.getPrice();
        this.getMyLocation()
    }
}
</script>
<style lang="less" scoped>
.addressBg {
    width: 750px;
    height: auto;
    display: flex;
    margin: 0px auto;
    background-image: url('../../img/address-bg.jpg');
    background-size: 100% 145px;
    background-repeat: no-repeat;
    .address_box {
        width: 90%;
        margin: 50px auto;
        .city {
            background-color: #fff;
            border-radius: 10px;
            height: 195px;
            box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
            .city_choice {
                width: 100%;
                height: 95px;
                line-height: 95px;
                border-bottom: 1px solid #f2f2f2;
                .dw {
                    width: 20px;
                    margin-left: 5%;
                    margin-top: 32px;
                    float: left;
                }
                p {
                    float: left;
                    margin-left: 15px;
                    font-size: 26px;
                }
                .qh {
                    width: 120px;
                    float: right;
                    margin-top: 30px;
                    margin-right: 20px;
                }
            }
            .city_show {
                padding: 0 30px;
                .city_show_1 {
                    width: 100%;
                    margin: 30px auto 0px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .el-cascader {
                        flex: 1;
                        border: 0px !important;
                        /deep/ .el-input__inner {
                            text-align: left;
                        }
                    }
                    .kf_btn {
                        padding: 10px 14px;
                        background-color: #ffda2d;
                        box-shadow: 3px 4px 6px 0 rgba(201, 201, 201, 0.26);
                        border-radius: 12px;
                        font-size: 18px;
                    }
                }
            }
        }
        .noPrice {
            height: 300px;
            font-size: 24px;
            border-radius: 15px;
            line-height: 300px;
        }
        .price {
            margin: 20px auto;
            padding: 37px;
            overflow: hidden;
            height: auto;
            // background-image: url('../../img/address-bg1.png');
            box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
            background-size: 700px 860px;
            background-repeat: no-repeat;
            border-radius: 15px;
            .price1 {
                height: 125px;
                border-bottom: 1px solid #d5d5d5;
                display: flex;
            }
            .price1_1 {
                width: 407px;
                height: 73px;
                margin: 15px auto 0px;
                background-image: url('../../img/address-bg2.png');
                background-size: 100%;
                background-repeat: no-repeat;
                color: #333;
                line-height: 73px;
                font-size: 1.3rem;
                font-weight: 700;
            }
            .price4 {
                display: flex;
                flex-direction: column;
                margin-top: 30px;
                margin-bottom: 20px;
            }
            .price2 {
                height: auto;
                border-bottom: 1px solid #d5d5d5;
                display: flex;
                flex-direction: column;
                .p_box {
                    width: 80%;
                    display: flex;
                    flex-direction: row;
                    text-align: center;
                    margin: 60px auto 0px;
                }
                .dbx {
                    width: 32px;
                    height: 40px;
                    display: inline;
                    margin-right: 20px;
                    margin-top: 20px;
                }
                .dbx1 {
                    width: 32px;
                    height: 40px;
                    margin-left: 20px;
                    margin-top: 20px;
                }
                .p1 {
                    font-size: 1.2rem;
                    line-height: -20px;
                    margin-top: 20px;
                    span {
                        font-size: 1.2rem;
                        color: #f34845;
                    }
                }
                .p2 {
                    width: 60%;
                    margin: 30px auto 0px;
                    font-size: 1.5rem;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #ffd104;
                }
                .p3 {
                    margin-top: 10px;
                    font-size: 1.5rem;
                }
                .p4 {
                    margin-top: 20px;
                    font-size: 1.2rem;
                    span {
                        color: #f34845;
                    }
                }
                .p5 {
                    margin-top: 30px;
                    font-size: 1.1rem;
                }
                .p6 {
                    margin-top: 20px;
                    font-size: 1.1rem;
                }
                .p7 {
                    font-size: 1.3rem;
                }
                .p8 {
                    font-size: 1.2rem;
                }
                .p9 {
                    font-size: 1.2rem;
                    margin-top: 15px;
                    margin-bottom: 30px;
                }
            }
            .price3 {
                display: flex;
                flex-direction: column;
                padding-top: 20px;
                border-top: 1px dotted #d5d5d5;
                position: relative;
                font-size: 24px;
                &::before {
                    content: '';
                    left: -65px;
                    top: -25px;
                    width: 50px;
                    height: 50px;
                    background-color: #ffdb29;
                    border-radius: 100%;
                    position: absolute;
                }
                &::after {
                    content: '';
                    right: -65px;
                    top: -25px;
                    width: 50px;
                    height: 50px;
                    background-color: #ffdb29;
                    border-radius: 100%;
                    position: absolute;
                }
                .p5 {
                    margin: 30px auto 0px;
                    font-size: 1.2rem;
                }
                .p6 {
                    margin-top: 20px;
                    font-size: 1.2rem;
                }
            }
        }
        .topPrice {
            padding: 0 !important;
        }
    }
}
@media screen and (min-width: 750px) {
    .addressBg {
        height: 1200px;
    }
}
@media screen and (min-width: 1200px) {
    .addressBg .address_box .price .price2 .p1 {
        font-size: 1.4rem;
        line-height: 60px;
    }
    .addressBg .address_box .price .price2 .p2 {
        font-size: 1rem;
    }
    .addressBg .address_box .price .price2 .p3 {
        font-size: 1rem;
    }
    .addressBg .address_box .price .price2 .p4 {
        font-size: 1rem;
    }
    .addressBg .address_box .price .price2 .p5 {
        font-size: 0.8rem;
    }
    .addressBg .address_box .price .price3 .p7 {
        font-size: 1rem;
    }
    .addressBg .address_box .price .price3 .p8 {
        font-size: 1rem;
    }
}
.chagrgeStandard_wrap {
    width: 100%;
    height: 100%;
}
.item {
    padding: 20px;
    display: flex;
    justify-content: space-between;
}
.item_label {
    flex: 0.8;
    text-align: left;
    font-size: 30px;
    font-weight: bold;
}
.item_value {
    flex: 1;
    font-size: 26px;
    color: #999;
    text-align: right;
}
.item_tip {
    margin-top: 10px;
    font-weight: normal;
    font-size: 24px;
    color: #999;
}
.border_item {
    margin: 0 20px;
    padding-bottom: 20px;
    border-top: 2px solid #efefef;
}
.c-mb-10 {
    margin-bottom: 10px;
}
.col_red {
    color: #ff596a !important;
}
.outside {
    border-top: 1px solid #efefef;
    padding-top: 10px;
}
.ques_wrap{
      margin-top: 50px;
      padding-bottom: 30px;
  }
  .ques_wrap .title{
    text-align: center;
    font-size: 32px;
    line-height: 30px;
  }
  .ques_uls .ques_lis{
      margin-top: 30px;
  }
  .ques_lis_flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .lis_title{
      font-size: 26px;
  }
  .img_arrow{
    width: 30px;
    height: 30px;
  }
  .up{
      rotate: 90deg;
  }
  .down{
    rotate: 270deg;
  }
  .lis_detail{
      margin-top: 20px;
      font-size: 24px;
      line-height: 40px;
      color: #999;
      p{
        text-align: left;
      }
  }
  /* 隐藏滚动条 */
::-webkit-scrollbar {
    display: none;
}
/* 超出容器宽度隐藏部分 */
.m_container::-webkit-scrollbar {
    display: none;
}
  .m-tab{
    width: 100%;
    white-space: nowrap;
    display: flex;
    align-items: center;
    text-align: center;
    margin: 40px 0;
    overflow-x: scroll;
}
.m-tab .tab-item{
    font-size: 28px;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
    position: relative;
}
.m-tab .tab-item.activeClass{
  color: #f1574d
}
.m-tab .tab-item.activeClass::after{
  content: '';
  width: 35px;
  height: 3px;
  background: #f1574d;
  position: absolute;
  bottom: 10%;
  left: 43%;
}
.m-tab .tab-item:nth-child(1):before{
  content: '';
  width: 2px;
  height: 30rpx;
  background: #ebebeb;
  position: absolute;
  top: 36%;
  right: 0;
}
</style>
<style lang="less">
.el-cascader-menu__wrap {
    height: 600px !important;
}
.el-input__inner {
    text-align: center;
    border: 0px;
}
.el-input__icon {
    display: none;
}
.city_show {
    .el-input {
        font-size: 32px;
        text-align: center;
    }
    .el-cascader {
        border: 0px;
    }
    .el-input__inner {
        border: 0px;
    }
    .el-input__suffix {
        display: none;
    }
}
.el-cascader-menu {
    min-width: 225px !important;
}
.el-cascader-panel {
    font-size: 28px !important;
}
.el-cascader-node.in-active-path {
    height: 60px !important;
    color: #f34845 !important;
}
.el-cascader-node {
    height: 60px !important;
    line-height: 60px !important;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #f34845 !important;
}
.el-cascader-node__prefix {
    left: 285px !important;
}
</style>
<style lang="less">
@media screen and (max-width: 750px) {
}
</style>



// WEBPACK FOOTER //
// src/views/address/address.vue